const { FormattedText } = require('core/i18n').i18n;
const PropTypes = require('prop-types');
const React = require('react');
//@helpers
const { formatInterest } = require('utilities/currencyHelper');
import { getIsFullProfitability } from 'utilities/depositHelper'
//@constants
const { FOOTER_CONFIG } = require('./constants/step1OutsideFooterConfig');

class Step1OutsideFooter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { contractWizard, originCountry } = this.props;
        const depositsAllowed = !contractWizard.getIn(['mainDeposits', 'isFetching']) ? contractWizard.getIn(['mainDeposits', 'data']).toJS() : null;
        let content;
        if (!depositsAllowed) {
            content = null;
        } else {
            const isPassportCountry = !getIsFullProfitability(originCountry)
            const isSameTinTae = depositsAllowed.depositConfig.tin === depositsAllowed.depositConfig.tae
            const keyTinAndTaeExample1 = isSameTinTae || isPassportCountry ? FOOTER_CONFIG[contractWizard.get('name_contract')].example1 : FOOTER_CONFIG[contractWizard.get('name_contract')].example1Full
            const injectedStringsTinTae = [
                ...(isSameTinTae || isPassportCountry ? [] : formatInterest(depositsAllowed.depositConfig.tae, false)),
                formatInterest(depositsAllowed.depositConfig.tin, false),
                depositsAllowed.depositConfig.months
            ]

            content = (
                <ul className="step1deposittransfer__outsidefooter">
                    <li>
                        <FormattedText value={keyTinAndTaeExample1} injectedStrings={injectedStringsTinTae} />
                    </li>
                    <li>
                        <FormattedText
                            value={FOOTER_CONFIG[contractWizard.get('name_contract')].example2}
                            injectedStrings={[
                                depositsAllowed.depositConfig.months,
                                depositsAllowed.exampleInterestAmount
                            ]}
                        />
                    </li>
                    <li>
                        <FormattedText
                            value={FOOTER_CONFIG[contractWizard.get('name_contract')].example3}
                            injectedStrings={[
                                depositsAllowed.depositConfig.months,
                                depositsAllowed.cancelMonths,
                                formatInterest(depositsAllowed.cancelCost, false),
                                depositsAllowed.exampleInterestAmountCancelled
                            ]}
                        />
                    </li>
                </ul>
            )
        }
        return content;
    }
}

Step1OutsideFooter.propTypes = {
    contractWizard: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
};

module.exports = Step1OutsideFooter;
